export const categories = [
  {
    id: 'lishi-qiyuan',
    slug: 'lishi-qiyuan',
    name: '历史起源',
    nameEn: 'History & Origins',
    description: '追溯日本里番动画从20世纪80年代至今的发展脉络，探讨其诞生背景、关键历史节点与产业演变过程。',
    icon: 'ri-history-line',
    articleCount: 8,
    color: 'primary',
  },
  {
    id: 'leixing-fenlei',
    slug: 'leixing-fenlei',
    name: '类型分类',
    nameEn: 'Genre Classification',
    description: '系统梳理日本里番的主要类型划分体系，包括题材分类、受众分类、制作风格分类等多个维度，帮助建立完整的认知框架。',
    icon: 'ri-stack-line',
    articleCount: 12,
    color: 'accent',
  },
  {
    id: 'wenhua-beijing',
    slug: 'wenhua-beijing',
    name: '文化背景',
    nameEn: 'Cultural Background',
    description: '深入分析日本里番与社会文化语境的关系，包括日本御宅文化、性别观念、法律制度、社会接受度等多重因素的交织影响。',
    icon: 'ri-global-line',
    articleCount: 6,
    color: 'secondary',
  },
  {
    id: 'chanye-fenxi',
    slug: 'chanye-fenxi',
    name: '产业分析',
    nameEn: 'Industry Analysis',
    description: '从商业角度审视日本里番产业的市场规模、制作流程、发行渠道、商业模式及数字化时代的转型趋势。',
    icon: 'ri-line-chart-line',
    articleCount: 5,
    color: 'primary',
  },
  {
    id: 'guankan-xuzhi',
    slug: 'guankan-xuzhi',
    name: '观看须知',
    nameEn: 'Viewing Guidelines',
    description: '提供合规观看日本里番的注意事项，包括年龄限制、平台选择、法律边界、心理健康建议等实用指导信息。',
    icon: 'ri-shield-check-line',
    articleCount: 7,
    color: 'accent',
  },
];

export const allArticles = [
  {
    id: 'article-1',
    slug: 'riben-lifan-dingyi-yu-gainian-jiexi',
    title: '日本里番的定义与概念解析',
    excerpt: '本文从学术角度系统阐述"里番"这一术语的起源、定义边界及其在日本动画产业中的定位，辨析其与一般成人动画的区别与联系。',
    content: '',
    categoryId: 'leixing-fenlei',
    categoryName: '类型分类',
    date: '2026-07-15',
    readTime: 12,
    imageSeq: 'article-def-01',
    imageQuery: 'Japanese%20animation%20studio%20workspace%20with%20drawing%20table%20and%20storyboard%20frames%20on%20wall%2C%20warm%20ambient%20lighting%2C%20professional%20anime%20production%20environment%2C%20clean%20and%20organized%2C%20editorial%20photography%20with%20soft%20shadows',
    featured: true,
    tags: ['里番定义', '动画分类', '术语解析'],
    contentHtml: '',
  },
  {
    id: 'article-2',
    slug: 'lifan-donghua-fazhan-jianshi-1980-2025',
    title: '里番动画发展简史（1984–2025）',
    excerpt: '从1984年第一部OVA里番作品诞生至今，全面回顾日本里番动画四十余年的发展历程，梳理各个时期的代表作品与产业特征。',
    content: '',
    categoryId: 'lishi-qiyuan',
    categoryName: '历史起源',
    date: '2026-07-10',
    readTime: 18,
    imageSeq: 'article-hist-01',
    imageQuery: 'Retro%20Japanese%20VHS%20tape%20collection%20displayed%20on%20wooden%20shelves%20with%20vintage%20anime%20artwork%20covers%2C%201980s%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20cultural%20archival%20photography',
    featured: true,
    tags: ['发展史', 'OVA时代', '产业演变'],
    contentHtml: '',
  },
  {
    id: 'article-3',
    slug: 'riben-yuzhai-wenhua-yu-lifan-guanxi',
    title: '日本御宅文化与里番的关系研究',
    excerpt: '探讨日本御宅文化的形成、演变及其与里番动画之间的深层互动关系，分析御宅群体的消费行为与文化认同机制。',
    content: '',
    categoryId: 'wenhua-beijing',
    categoryName: '文化背景',
    date: '2026-07-05',
    readTime: 15,
    imageSeq: 'article-cult-01',
    imageQuery: 'Japanese%20Akihabara%20district%20with%20anime%20posters%20and%20electronics%20stores%2C%20urban%20cultural%20landscape%2C%20warm%20evening%20neon%20glow%2C%20documentary%20style%20photography%20with%20cinematic%20composition',
    featured: true,
    tags: ['御宅文化', '亚文化', '消费行为'],
    contentHtml: '',
  },
  {
    id: 'article-4',
    slug: 'lifan-zhizuo-liucheng-xiangjie',
    title: '里番制作流程详解：从企划到发行',
    excerpt: '深入解析日本里番动画的完整制作流程，包括企划立项、剧本创作、分镜绘制、原画制作、后期配音到最终发行的全链路介绍。',
    content: '',
    categoryId: 'chanye-fenxi',
    categoryName: '产业分析',
    date: '2026-06-28',
    readTime: 14,
    imageSeq: 'article-ind-01',
    imageQuery: 'Professional%20animation%20studio%20interior%20with%20digital%20drawing%20tablets%20and%20color%20scripts%20displayed%2C%20clean%20modern%20workspace%2C%20soft%20diffused%20lighting%2C%20editorial%20photography',
    featured: false,
    tags: ['制作流程', '动画工业', '企划'],
    contentHtml: '',
  },
  {
    id: 'article-5',
    slug: 'chengren-donghua-hegui-guankan-zhinan',
    title: '成人动画合规观看指南与法律须知',
    excerpt: '系统介绍在不同国家和地区合法观看成人动画的相关法律法规、年龄验证机制、平台合规要求及个人隐私保护建议。',
    content: '',
    categoryId: 'guankan-xuzhi',
    categoryName: '观看须知',
    date: '2026-07-20',
    readTime: 10,
    imageSeq: 'article-guide-01',
    imageQuery: 'Modern%20minimalist%20home%20viewing%20setup%20with%20large%20monitor%20and%20comfortable%20lighting%2C%20clean%20aesthetic%20room%2C%20soft%20warm%20ambient%20light%2C%20editorial%20interior%20photography',
    featured: true,
    tags: ['合规观看', '法律法规', '年龄验证'],
    contentHtml: '',
  },
  {
    id: 'article-6',
    slug: 'lifan-leixing-huafen-biaozhun',
    title: '里番类型划分标准与分类体系',
    excerpt: '基于日本动画产业的实际分类标准，详细介绍里番的类型划分方法论，包括按题材、受众、叙事结构的多种分类模型。',
    content: '',
    categoryId: 'leixing-fenlei',
    categoryName: '类型分类',
    date: '2026-07-08',
    readTime: 13,
    imageSeq: 'article-type-01',
    imageQuery: 'Organized%20library%20of%20categorized%20Japanese%20animation%20art%20books%20on%20wooden%20shelves%2C%20academic%20setting%2C%20warm%20reading%20room%20lighting%2C%20scholarly%20atmosphere%20photography',
    featured: false,
    tags: ['分类体系', '类型学', '方法论'],
    contentHtml: '',
  },
  {
    id: 'article-7',
    slug: 'shuzi-shidai-lifan-chanye-bianqian',
    title: '数字时代里番产业的变迁与挑战',
    excerpt: '分析互联网和数字技术对日本里番产业带来的深刻变革，包括流媒体平台的崛起、实体媒介的衰落及全球化发行的新机遇。',
    content: '',
    categoryId: 'chanye-fenxi',
    categoryName: '产业分析',
    date: '2026-06-20',
    readTime: 11,
    imageSeq: 'article-dig-01',
    imageQuery: 'Modern%20digital%20content%20creation%20workspace%20with%20multiple%20screens%20displaying%20animation%20timeline%2C%20clean%20tech%20office%2C%20cool%20ambient%20lighting%2C%20professional%20technology%20photography',
    featured: false,
    tags: ['数字化', '流媒体', '产业转型'],
    contentHtml: '',
  },
  {
    id: 'article-8',
    slug: 'riben-lifan-falv-jianguan-kuangjia',
    title: '日本里番的法律监管框架详解',
    excerpt: '详细介绍日本对成人动画内容的法律监管体系，包括映像伦理机构审查、青少年保护条例及近年来的法规调整动态。',
    content: '',
    categoryId: 'wenhua-beijing',
    categoryName: '文化背景',
    date: '2026-07-01',
    readTime: 16,
    imageSeq: 'article-law-01',
    imageQuery: 'Japanese%20government%20building%20exterior%20with%20cherry%20blossom%20trees%2C%20formal%20institutional%20architecture%2C%20clear%20daylight%2C%20documentary%20architectural%20photography',
    featured: false,
    tags: ['法律监管', '审查制度', '青少年保护'],
    contentHtml: '',
  },
  {
    id: 'article-9',
    slug: 'lifan-donghua-xinli-jiankang-sikao',
    title: '里番动画与心理健康的理性思考',
    excerpt: '从心理学视角审视成人动画消费与心理健康的关系，提供理性消费的建议，帮助成年观众建立健康的观看习惯与认知框架。',
    content: '',
    categoryId: 'guankan-xuzhi',
    categoryName: '观看须知',
    date: '2026-07-18',
    readTime: 9,
    imageSeq: 'article-psy-01',
    imageQuery: 'Calm%20and%20serene%20meditation%20space%20with%20soft%20natural%20light%20streaming%20through%20window%2C%20minimalist%20interior%20with%20plants%2C%20peaceful%20wellness%20atmosphere%2C%20editorial%20photography',
    featured: false,
    tags: ['心理健康', '理性消费', '认知框架'],
    contentHtml: '',
  },
  {
    id: 'article-10',
    slug: 'OVA-dao-liumeiti-lifan-chuanbo-jinjie',
    title: '从OVA到流媒体：里番传播媒介的演进',
    excerpt: '追踪日本里番从VHS录像带、DVD/Blu-ray到网络下载和流媒体订阅的传播媒介变迁，分析不同媒介阶段对内容形态和消费模式的影响。',
    content: '',
    categoryId: 'lishi-qiyuan',
    categoryName: '历史起源',
    date: '2026-06-25',
    readTime: 14,
    imageSeq: 'article-media-01',
    imageQuery: 'Evolution%20of%20media%20formats%20displayed%20chronologically%20from%20VHS%20to%20Blu-ray%20to%20streaming%20icon%2C%20clean%20museum-style%20exhibition%2C%20soft%20gallery%20lighting%2C%20educational%20display%20photography',
    featured: false,
    tags: ['媒介变迁', 'OVA', '流媒体'],
    contentHtml: '',
  },
  {
    id: 'article-11',
    slug: 'lifan-yu-yiban-donghua-bijiao-fenxi',
    title: '里番与一般向动画的比较分析',
    excerpt: '从叙事结构、角色塑造、制作预算、受众定位等多个维度对比分析里番动画与一般向日本动画的异同，揭示两者的产业生态差异。',
    content: '',
    categoryId: 'leixing-fenlei',
    categoryName: '类型分类',
    date: '2026-07-03',
    readTime: 11,
    imageSeq: 'article-comp-01',
    imageQuery: 'Side%20by%20side%20comparison%20of%20two%20animation%20style%20boards%20on%20studio%20wall%2C%20professional%20art%20direction%20setting%2C%20clean%20studio%20lighting%2C%20editorial%20photography',
    featured: false,
    tags: ['比较分析', '一般向动画', '产业差异'],
    contentHtml: '',
  },
  {
    id: 'article-12',
    slug: 'guoji-shichang-riben-lifan-chukou',
    title: '国际市场中的日本里番出口现状',
    excerpt: '分析日本里番动画在国际市场的出口策略、本地化处理、文化适应及海外粉丝群体的分布特征，展望全球化背景下的发展前景。',
    content: '',
    categoryId: 'chanye-fenxi',
    categoryName: '产业分析',
    date: '2026-07-12',
    readTime: 12,
    imageSeq: 'article-glob-01',
    imageQuery: 'International%20shipping%20and%20trade%20concept%20with%20world%20map%20and%20cultural%20exchange%20icons%2C%20clean%20corporate%20style%2C%20professional%20business%20photography%20with%20warm%20lighting',
    featured: false,
    tags: ['国际市场', '出口', '本地化'],
    contentHtml: '',
  },
  {
    id: 'article-13',
    slug: 'lifan-neirong-shencha-jizhi-yanjiu',
    title: '里番内容审查机制的比较研究',
    excerpt: '横向比较日本、欧美、东亚各国对成人动画内容的审查标准与执行机制，探讨文化差异对审查尺度的深刻影响。',
    content: '',
    categoryId: 'wenhua-beijing',
    categoryName: '文化背景',
    date: '2026-07-07',
    readTime: 15,
    imageSeq: 'article-censor-01',
    imageQuery: 'Official%20document%20and%20regulation%20books%20stacked%20on%20desk%20with%20reading%20lamp%2C%20legal%20research%20setting%2C%20warm%20library%20lighting%2C%20scholarly%20photography',
    featured: false,
    tags: ['审查机制', '国际比较', '文化差异'],
    contentHtml: '',
  },
  {
    id: 'article-14',
    slug: 'chengnian-yonghu-lifan-guankan-suyang',
    title: '成年用户里番观看素养培养',
    excerpt: '面向成年观众，提供培养批判性观看素养的方法论指导，包括内容辨别、信息筛选、文化理解与自我反思能力的系统性提升建议。',
    content: '',
    categoryId: 'guankan-xuzhi',
    categoryName: '观看须知',
    date: '2026-07-22',
    readTime: 8,
    imageSeq: 'article-lit-01',
    imageQuery: 'Person%20reading%20and%20taking%20notes%20at%20a%20clean%20modern%20desk%20with%20laptop%2C%20educational%20self-improvement%20setting%2C%20soft%20natural%20light%2C%20editorial%20lifestyle%20photography',
    featured: false,
    tags: ['媒介素养', '批判思维', '自我反思'],
    contentHtml: '',
  },
];

export const featuredArticles = allArticles.filter(a => a.featured);

export const faqItems = [
  {
    question: '什么是日本里番？它与一般成人动画有何区别？',
    answer: '日本里番（裏番組）是日本动画产业中的一个特殊分支，指面向成年观众制作的、包含成人内容的动画作品。与一般成人动画的区别在于：里番通常不通过电视公开播放，而是采取OVA、网络发行等非公开渠道流通；其制作预算相对较低，制作周期较短；内容尺度通常大于一般深夜动画。从产业分类角度看，里番属于日本动画产业中一个独立的垂直细分市场。',
  },
  {
    question: '日本里番动画的历史可以追溯到什么时候？',
    answer: '日本里番动画的历史可追溯到20世纪80年代初期。1984年被认为是里番动画产业化的重要起点，当时随着家用录像机（VCR）在日本的普及，OVA（Original Video Animation）这一新的发行形式为成人向动画提供了绕开电视审查的流通渠道。此后经历了VHS时代、DVD时代、网络下载时代直至如今的流媒体时代，已有超过四十年的发展历史。',
  },
  {
    question: '如何合法合规地观看日本里番动画？',
    answer: '合法合规观看日本里番动画需注意以下几点：第一，确保观看者本人已满法定成年年龄（通常为18岁或以上）；第二，通过正规授权的发行平台或渠道获取内容；第三，了解所在国家或地区对成人内容的法规要求；第四，注意个人隐私保护，避免在不安全的网络环境下访问相关平台。各国法律对成人内容的规定存在显著差异，观看前务必确认当地法规。',
  },
  {
    question: '里番动画的主要类型有哪些？',
    answer: '日本里番动画的类型分类可从多个维度进行：按题材可分为校园、奇幻、科幻、历史、都市等；按受众定位可分为男性向、女性向及中性向；按制作质量可分为高品质剧场版、中等品质OVA系列及低预算快速出品；按内容风格可分为剧情主导型、氛围营造型等。了解这些分类有助于更精准地找到符合个人偏好的作品类型。',
  },
  {
    question: '观看里番动画是否会影响心理健康？',
    answer: '关于里番动画与心理健康的关系，学术界尚存不同观点。从理性视角来看，适度、有选择地观看成人内容对心理健康的影响因人而异。关键在于建立健康的消费习惯：保持适度观看频率、培养批判性媒介素养、区分虚构与现实、关注自身情绪变化。如感到观看行为已影响日常生活或心理健康，建议寻求专业心理咨询师的帮助。',
  },
  {
    question: '日本里番与主流深夜动画的界限在哪里？',
    answer: '日本里番与主流深夜动画（深夜アニメ）的界限主要体现在以下方面：播出渠道上，深夜动画仍通过电视台播出，而里番不走电视渠道；内容尺度上，里番的成人内容表现更为直接；审查标准上，深夜动画受放送伦理机构约束，而里番走的是映像伦理机构的自主审查路径；商业模式上，深夜动画依赖赞助商和周边衍生，里番则主要依赖直接销售和订阅。',
  },
];

export const teamMembers = [
  {
    name: '林文轩',
    role: '创始人 & 主编',
    bio: '日本动画文化研究学者，东京大学媒体研究硕士，专注日本亚文化领域研究超过十五年。',
    avatarSeq: 'team-01',
  },
  {
    name: '王思涵',
    role: '内容总监',
    bio: '资深动画评论人，曾任职于多家动画媒体平台，对日本动画产业有深入的田野调查经验。',
    avatarSeq: 'team-02',
  },
  {
    name: '陈志远',
    role: '研究顾问',
    bio: '文化社会学博士，研究方向为东亚大众文化与亚文化群体，多篇学术论文发表于国际期刊。',
    avatarSeq: 'team-03',
  },
];

export const milestones = [
  { year: '2018', event: '里番文化研究所正式成立，首发三篇深度研究文章' },
  { year: '2019', event: '建立完整的日本里番动画数据库，收录2000+作品信息' },
  { year: '2020', event: '与东京多所大学建立学术合作关系，开展联合研究项目' },
  { year: '2021', event: '网站月访问量突破50万，成为中文领域最权威的里番文化研究平台' },
  { year: '2022', event: '出版首部学术专著《日本成人动画文化研究》' },
  { year: '2023', event: '启动国际学术交流计划，与欧美亚文化研究机构建立联系' },
  { year: '2024', event: '完成平台全面升级，推出多语言版本与移动端适配' },
  { year: '2025', event: '累计发表研究文章超过500篇，注册研究员超过100人' },
];